module.exports = __webpack_public_path__ + "img/MGH-Yokohama-1.91dcd833.jpg";